import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/featureOnboardingModalQuery$parameters';
import type { featureOnboardingModalQuery } from './__generated__/featureOnboardingModalQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	hamsProductKey: string;
};

export const entryPoint: EntryPoint<
	EntryPointComponent<
		{
			featureOnboardingModalQuery: featureOnboardingModalQuery;
		},
		Record<string, never>,
		{
			isAutoOpened?: boolean;
			onClose: () => void;
		},
		Record<string, never>
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-feature-onboarding-modal" */ './feature-onboarding-modal'
			),
		{
			moduleId: 'edition-awareness-feature-onboarding-modal',
		},
	),
	getPreloadProps: ({ cloudId, hamsProductKey }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			featureOnboardingModalQuery: {
				parameters,
				variables: {
					cloudId,
					hamsProductKey,
				},
			},
		},
	}),
});
